module.exports = __webpack_public_path__ + "img/cloud2.c34ee0fe.png";